import { get, getDictMap } from '@/api/dictDetail'

export default {
  data() {
    return {
      dicts: [], dictMap: {}
    }
  },
  methods: {
    async getDict(name) {
      return new Promise((resolve, reject) => {
        get(name).then(res => {
          this.dicts = res.content
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    //当有多个dict的时候,用这个方法来分别设置dictMap对象
    async setDict(name) {
      return new Promise((resolve, reject) => {
        get(name).then(res => {
          //this.dictMap[name] = res.content
          //vue中直接添加属性不会渲染,使用vue set 吧
          this.$set(this.dictMap, name, res.content)

          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 多个字典查询时使用逗号拼接， 如：
    // 加载多个数据字典，如何调用如下：
    // this.getDict('user_status,job_status')
    // 在vue中使用加载出来的字典：
    // dictMap.[字典名称] 如：dictMap.user_status、 dictMap.job_status
    async getDictMap(names) {
      // 优先放入到dictMap中，避免页面加载时 undefined

      const arr = names.split(',')
      for (let i = 0; i < arr.length; i++) {

         this.setDict(arr[i])

      }

    },
    //多字典查询，用v-for太麻烦啦
   getDictMapItem(dictName,value) {
	
      if(this.dictMap[dictName]){
        for(var o of this.dictMap[dictName]){

          if(o.value===value) return o

        }
      }
      //返回这个对象，防止出现undefined错误导致无法编译
      return {
              "dictName":null,
              "id":null,
              "label":null,
              "sort":null,
              "value":null
              }
    }

  }
}
